(function () {
  'use strict';

  var COUPON_API_BASE = 'https://api.tripcnguide.com/api/v1/coupons';
  var BUSINESS_LABELS = { TRAIN: 'train ticket', ESIM: 'eSIM', TRAVEL: 'travel' };

  function CouponSelector(root, options) {
    this.root = root;
    this.options = options || {};
    this.businessType = this.options.businessType || 'TRAIN';
    this.email = this.options.email || '';
    this.orderAmount = Number(this.options.orderAmount) || 0;
    this.isLoggedIn = this.options.isLoggedIn !== false;
    this.onSelect = this.options.onSelect || null;

    this.selectedCoupon = null;
    this.coupons = [];
    this.loaded = false;

    this.init();
  }

  CouponSelector.prototype.init = function () {
    this.triggerButton = this.root.querySelector('[data-coupon-toggle]');
    this.triggerText = this.root.querySelector('[data-coupon-trigger-text]');
    this.panel = this.root.querySelector('[data-coupon-panel]');
    this.loadingEl = this.root.querySelector('[data-coupon-loading]');
    this.listEl = this.root.querySelector('[data-coupon-list]');
    this.emptyEl = this.root.querySelector('[data-coupon-empty]');
    this.errorEl = this.root.querySelector('[data-coupon-error]');
    this.errorTextEl = this.root.querySelector('[data-coupon-error-text]');
    this.selectedEl = this.root.querySelector('[data-coupon-selected]');
    this.selectedNameEl = this.root.querySelector('[data-coupon-selected-name]');
    this.selectedDiscountEl = this.root.querySelector('[data-coupon-selected-discount]');
    this.removeButton = this.root.querySelector('[data-coupon-remove]');

    var self = this;

    this.triggerButton.addEventListener('click', function () {
      if (!self.isLoggedIn) {
        self.promptLogin();
        return;
      }
      if (self.panel.hidden) {
        if (window.tcng) window.tcng.track('coupon_selector_open');
        self.openPanel();
      } else {
        self.closePanel();
      }
    });

    this.removeButton.addEventListener('click', function () {
      if (window.tcng) window.tcng.track('coupon_removed');
      self.clearSelection();
    });

    // Update trigger text based on actual login status
    this.updateTriggerText();
  };

  CouponSelector.prototype.updateTriggerText = function () {
    if (!this.selectedCoupon) {
      this.triggerText.textContent = this.isLoggedIn ? 'Use Coupon' : 'Log in to use coupons';
    }
  };

  CouponSelector.prototype.redirectToLogin = function () {
    var returnUrl = encodeURIComponent(window.location.href);
    window.location.href = '/account/login?return_url=' + returnUrl;
  };

  CouponSelector.prototype.promptLogin = function () {
    var self = this;
    var auth = window.TripCNAuth;
    if (!auth || typeof auth.requireLogin !== 'function') {
      this.redirectToLogin();
      return;
    }
    // The login modal is a fixed-position overlay, not a <dialog>, so it can't
    // paint above a host <dialog> shown via showModal() (native dialogs render
    // in the browser's top layer, above regular stacking contexts). Callers
    // that host this selector inside a <dialog> pass beforeLogin/afterLogin
    // hooks to close/reopen it around the login flow.
    var beforeLogin = this.options.beforeLogin;
    var afterLogin = this.options.afterLogin;
    if (typeof beforeLogin === 'function') beforeLogin();
    auth.requireLogin().then(function (user) {
      if (typeof afterLogin === 'function') afterLogin(user);
      if (!user) return;
      self.isLoggedIn = true;
      if (user.email) self.setEmail(user.email);
      self.updateTriggerText();
      self.openPanel();
    });
  };

  CouponSelector.prototype.getAuthToken = function () {
    var auth = window.TripCNAuth;
    return auth && typeof auth.getAccessToken === 'function' ? auth.getAccessToken() : '';
  };

  CouponSelector.prototype.openPanel = function () {
    this.panel.hidden = false;
    this.triggerButton.setAttribute('aria-expanded', 'true');

    if (!this.loaded) {
      this.loadCoupons();
    }
  };

  CouponSelector.prototype.closePanel = function () {
    this.panel.hidden = true;
    this.triggerButton.setAttribute('aria-expanded', 'false');
  };

  CouponSelector.prototype.loadCoupons = function () {
    var self = this;
    this.loaded = true;
    this.showLoading();

    this.fetchCoupons().then(function (coupons) {
      self.coupons = coupons;
      self.render();
    }).catch(function (error) {
      self.showError(error.message || 'Failed to load coupons');
    });
  };

  CouponSelector.prototype.fetchCoupons = function () {
    // 刻意不传 businessType：服务端会把不适用的券直接过滤掉，
    // 而这里要的是"全部券 + 当前业务不适用的置灰"，由 filterApplicable 本地判定。
    var url = COUPON_API_BASE + '/available?email=' + encodeURIComponent(this.email);
    var token = this.getAuthToken();
    var headers = { Accept: 'application/json' };
    if (token) headers.Authorization = 'Bearer ' + token;

    return fetch(url, { headers: headers }).then(function (response) {
      return response.json().catch(function () { return null; }).then(function (json) {
        if (!response.ok || !json) throw new Error('Service temporarily unavailable. Please try again later.');
        if (String(json.code) !== '200' && String(json.code) !== '0' && String(json.code).toUpperCase() !== 'SUCCESS') {
          throw new Error(json.msg || json.message || 'Failed to load coupons');
        }
        return json.data !== undefined && json.data !== null ? (Array.isArray(json.data) ? json.data : []) : [];
      });
    });
  };

  CouponSelector.prototype.showLoading = function () {
    this.loadingEl.hidden = false;
    this.listEl.hidden = true;
    this.emptyEl.hidden = true;
    this.errorEl.hidden = true;
  };

  CouponSelector.prototype.showError = function (message) {
    this.loadingEl.hidden = true;
    this.listEl.hidden = true;
    this.emptyEl.hidden = true;
    this.errorEl.hidden = false;
    this.errorTextEl.textContent = message || 'Failed to load coupons';
  };

  CouponSelector.prototype.isApplicableBusiness = function (coupon) {
    var businesses = coupon.applicableBusinesses || coupon.businessType;
    if (businesses == null || businesses === '') return false;
    var list = Array.isArray(businesses) ? businesses : String(businesses).split(',');
    var target = String(this.businessType).toUpperCase();
    for (var i = 0; i < list.length; i++) {
      if (String(list[i]).trim().toUpperCase() === target) return true;
    }
    return false;
  };

  CouponSelector.prototype.filterApplicable = function (coupons) {
    var self = this;
    return (coupons || []).map(function (coupon) {
      var applicable = true;
      var reason = '';

      if (!self.isApplicableBusiness(coupon)) {
        applicable = false;
        reason = 'Not valid for ' + (BUSINESS_LABELS[String(self.businessType).toUpperCase()] || 'this') + ' orders';
      } else if (coupon.minOrderAmount && self.orderAmount < Number(coupon.minOrderAmount)) {
        applicable = false;
        reason = 'Minimum order $' + coupon.minOrderAmount;
      }

      return {
        coupon: coupon,
        applicable: applicable,
        reason: reason
      };
    });
  };

  CouponSelector.prototype.calculateDiscount = function (coupon) {
    if (!coupon) return 0;
    var amount = this.orderAmount;
    var discount = 0;

    switch (String(coupon.type || coupon.couponType || '').toUpperCase()) {
      case 'DISCOUNT':
        discount = amount * (Number(coupon.discountPercent) || 0) / 100;
        break;
      case 'CASH':
        discount = Number(coupon.cashAmount) || 0;
        break;
      case 'THRESHOLD':
        if (amount >= Number(coupon.thresholdAmount)) {
          discount = Number(coupon.thresholdDiscount) || 0;
        }
        break;
    }

    if (coupon.maxDiscount && discount > Number(coupon.maxDiscount)) {
      discount = Number(coupon.maxDiscount);
    }
    if (discount > amount) discount = amount;

    return Math.round(discount * 100) / 100;
  };

  CouponSelector.prototype.formatDiscountLabel = function (coupon) {
    if (!coupon) return '';
    switch (String(coupon.type || coupon.couponType || '').toUpperCase()) {
      case 'DISCOUNT':
        return Number(coupon.discountPercent) + '% off';
      case 'CASH':
        return '$' + Number(coupon.cashAmount).toFixed(2) + ' off';
      case 'THRESHOLD':
        return 'Spend $' + Number(coupon.thresholdAmount) + ', get $' + Number(coupon.thresholdDiscount) + ' off';
      default:
        return '';
    }
  };

  CouponSelector.prototype.formatExpiry = function (coupon) {
    var until = coupon.validUntil || coupon.validUntilDate || '';
    if (!until) return '';
    var date = new Date(until);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  CouponSelector.prototype.render = function () {
    var self = this;
    this.loadingEl.hidden = true;
    this.errorEl.hidden = true;

    var entries = this.filterApplicable(this.coupons);
    if (!entries.length) {
      this.listEl.hidden = true;
      this.listEl.innerHTML = '';
      this.emptyEl.hidden = false;
      return;
    }

    this.emptyEl.hidden = true;
    this.listEl.hidden = false;
    this.listEl.innerHTML = entries.map(function (entry, index) {
      var coupon = entry.coupon;
      var selected = self.selectedCoupon && String(self.selectedCoupon.id) === String(coupon.id);
      var disabled = !entry.applicable;
      return '<label class="coupon-card' + (selected ? ' is-selected' : '') + (disabled ? ' is-disabled' : '') + '"' +
        (disabled ? ' aria-disabled="true"' : '') + '>' +
        '<input type="radio" name="coupon-option" value="' + escapeHTML(coupon.id) + '"' +
          (selected ? ' checked' : '') + (disabled ? ' disabled' : '') + ' data-coupon-option="' + index + '">' +
        '<span class="coupon-card__body">' +
          '<strong class="coupon-card__name">' + escapeHTML(coupon.couponName || coupon.name || coupon.couponCode) + '</strong>' +
          '<span class="coupon-card__desc">' + escapeHTML(self.formatDiscountLabel(coupon)) + '</span>' +
          '<span class="coupon-card__meta">' +
            (entry.applicable ? 'Save $' + self.calculateDiscount(coupon).toFixed(2) + ' on this order' : escapeHTML(entry.reason)) +
            (self.formatExpiry(coupon) ? ' · Valid until ' + escapeHTML(self.formatExpiry(coupon)) : '') +
          '</span>' +
        '</span>' +
        '<span class="coupon-card__radio" aria-hidden="true"></span>' +
      '</label>';
    }).join('');

    this.listEl.querySelectorAll('[data-coupon-option]').forEach(function (input) {
      input.addEventListener('change', function () {
        var entry = entries[Number(input.getAttribute('data-coupon-option'))];
        if (entry && entry.applicable) self.selectCoupon(entry.coupon);
      });
    });
  };

  CouponSelector.prototype.selectCoupon = function (coupon) {
    this.selectedCoupon = coupon;
    var discount = this.calculateDiscount(coupon);

    if (window.tcng) {
      window.tcng.track('coupon_applied', {
        coupon: coupon.couponCode || coupon.couponName || coupon.name,
        discount_amount: Number(discount) || 0,
        currency: 'USD'
      });
    }

    this.selectedNameEl.textContent = coupon.couponName || coupon.name || coupon.couponCode;
    this.selectedDiscountEl.textContent = '-' + formatCurrency(discount);
    this.selectedEl.hidden = false;

    this.listEl.querySelectorAll('.coupon-card').forEach(function (card) {
      var input = card.querySelector('input');
      var isSelected = input && String(input.value) === String(coupon.id);
      card.classList.toggle('is-selected', isSelected);
    });

    this.triggerText.textContent = 'Coupon Applied';
    this.closePanel();

    if (this.onSelect) {
      this.onSelect({
        userCouponId: coupon.id,
        couponName: coupon.couponName || coupon.name || coupon.couponCode,
        discount: discount
      });
    }
  };

  CouponSelector.prototype.clearSelection = function () {
    this.selectedCoupon = null;
    this.selectedEl.hidden = true;
    this.selectedNameEl.textContent = '';
    this.selectedDiscountEl.textContent = '';
    this.updateTriggerText();

    this.listEl.querySelectorAll('.coupon-card').forEach(function (card) {
      card.classList.remove('is-selected');
      var input = card.querySelector('input');
      if (input) input.checked = false;
    });

    if (this.onSelect) {
      this.onSelect({ userCouponId: null, couponName: '', discount: 0 });
    }
  };

  // 下单提交的是券实例 ID（user_coupon.id），不是券码：券码是配置级标识，
  // 定位不到用户手上具体是哪一张，后端也无法据此核销。
  CouponSelector.prototype.getSelectedUserCouponId = function () {
    return this.selectedCoupon ? this.selectedCoupon.id : null;
  };

  CouponSelector.prototype.setOrderAmount = function (amount) {
    this.orderAmount = Number(amount) || 0;
    if (this.selectedCoupon) {
      var discount = this.calculateDiscount(this.selectedCoupon);
      this.selectedDiscountEl.textContent = '-' + formatCurrency(discount);
      if (this.onSelect) {
        this.onSelect({
          userCouponId: this.selectedCoupon.id,
          couponName: this.selectedCoupon.couponName || this.selectedCoupon.name || this.selectedCoupon.couponCode,
          discount: discount
        });
      }
    }
  };

  CouponSelector.prototype.setEmail = function (email) {
    this.email = email || '';
    this.loaded = false;
    this.coupons = [];
  };

  // Login state can change after the selector is constructed (e.g. a guest
  // logs in mid-session in a checkout dialog that stays mounted across opens).
  // Callers should re-sync this on every checkout open rather than trusting
  // the isLoggedIn value captured at construction time.
  CouponSelector.prototype.setIsLoggedIn = function (isLoggedIn) {
    var next = Boolean(isLoggedIn);
    if (next === this.isLoggedIn) return;
    this.isLoggedIn = next;
    this.loaded = false;
    this.coupons = [];
    if (!next) {
      this.clearSelection();
      this.closePanel();
    }
    this.updateTriggerText();
  };

  CouponSelector.prototype.refreshOrderAmount = function (amount) {
    var previous = this.orderAmount;
    this.orderAmount = Number(amount) || 0;
    if (this.selectedCoupon && this.orderAmount !== previous) {
      var discount = this.calculateDiscount(this.selectedCoupon);
      this.selectedDiscountEl.textContent = '-' + formatCurrency(discount);
      if (this.onSelect) {
        this.onSelect({
          userCouponId: this.selectedCoupon.id,
          couponName: this.selectedCoupon.couponName || this.selectedCoupon.name || this.selectedCoupon.couponCode,
          discount: discount
        });
      }
    }
  };

  // Expose global factory
  window.CouponSelector = CouponSelector;

  // Helper functions (module-local)
  function escapeHTML(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatCurrency(value) {
    var amount = Number(value || 0);
    return '$' + amount.toFixed(2);
  }
})();
